var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSecurity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1321",
    "data-name": "Group 1321",
    transform: "translate(-5829 -3231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_740",
    "data-name": "Path 740",
    d: "M5844.09,3250.5h-8.18a3.275,3.275,0,0,1-3.272-3.273v-4.908a3.275,3.275,0,0,1,3.272-3.272h8.18a3.275,3.275,0,0,1,3.272,3.272v4.908A3.275,3.275,0,0,1,5844.09,3250.5Zm-8.18-9.817a1.638,1.638,0,0,0-1.636,1.636v4.908a1.637,1.637,0,0,0,1.636,1.636h8.18a1.637,1.637,0,0,0,1.636-1.636v-4.908a1.638,1.638,0,0,0-1.636-1.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_741",
    "data-name": "Path 741",
    d: "M5843.681,3240.682h-7.362a.818.818,0,0,1-.818-.818h0V3237a4.5,4.5,0,1,1,9,0v2.863a.818.818,0,0,1-.817.818Zm-6.544-1.636h5.726V3237a2.863,2.863,0,1,0-5.726,0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_208",
    "data-name": "Ellipse 208",
    cx: 1.227,
    cy: 1.227,
    r: 1.227,
    transform: "translate(5838.773 3243.545)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_564",
    "data-name": "Rectangle 564",
    width: 22,
    height: 22,
    transform: "translate(5829 3231)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSecurity);
export default __webpack_public_path__ + "static/media/icon-security.b5a233719594bb268bcd1c3f2ec12742.svg";
export { ForwardRef as ReactComponent };